import React, { useState, useEffect } from "react";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Nikhila S",
    company: "Cognizant",
    avatar: "/successstories/A7DpYcrct.png",
    companyLogo: "/successstories/cognizant.png",
    text: `Before KodeZ, I was overwhelmed by AI. After KodeZ, I was *deploying* AI. The microservice I built during my internship wasn’t just a project—it became a real product. That’s transformation.`,
  },
  {
    name: "K Kiran Kumar",
    company: "DevDolphins",
    avatar: "/successstories/kirankumar.png",
    companyLogo: "/successstories/devdolphins.png",
    text: `KodeZ wasn’t just a course—it was a launchpad. By the time I reached my capstone, I already had an offer. I learned to think like a builder, and recruiters noticed that fast.`,
  },
  {
    name: "Sruthi G",
    company: "Hexaware",
    avatar: "/successstories/30xf9snapedit1724834616447.jpg",
    companyLogo: "/successstories/hexaware.png",
    text: `KodeZ taught me more than code. It taught me clarity, confidence, and communication. I now design, develop, and *defend* solutions—skills that helped me shine in interviews and beyond.`,
  },
  {
    name: "P Shiva",
    company: "DevDolphins",
    avatar: "/successstories/shiva.jpg",
    companyLogo: "/successstories/devdolphins.png",
    text: `From hesitant coder to confident contributor—KodeZ changed my mindset. The fast feedback loops and real‑world exposure helped me present ideas like a pro, not just push commits.`,
  },
  {
    name: "Uday Kiran",
    company: "Accenture",
    avatar: "/successstories/vwBcYuntitleddesign.png",
    companyLogo: "/successstories/accenture.png",
    text: `KodeZ helped me move from tutorial traps to production‑ready thinking. What I built in the program wasn’t just practice—it became portfolio‑worthy. That’s what employers loved.`,
  },
  {
    name: "BYS Lakshmi",
    company: "Capgemini",
    avatar: "/successstories/lakshmi.jpg",
    companyLogo: "/successstories/capgemini.png",
    text: `Every week at KodeZ felt like a product sprint. Clear goals, tight deadlines, and constant improvement. It prepared me not just for interviews—but for delivering value from day one.`,
  },
  {
    name: "Samhitha Y",
    company: "Infosys",
    avatar: "/successstories/nVMWvsnapedit1724834926932.png",
    companyLogo: "/successstories/sp1.png",
    text: `KodeZ unlocked the leader in me. I started off quietly writing code. I finished confidently pitching MVPs to industry mentors. That transformation helped me secure my role at Infosys.`,
  },
  {
    name: "Abhinaya V",
    company: "Cognizant",
    avatar: "/successstories/I3GvDsnapedit1725291560218.jpg",
    companyLogo: "/successstories/cognizant.png",
    text: `At KodeZ, I built more than apps—I built confidence. It wasn’t just about writing JavaScript or Python, it was about telling a story with tech. And that story opened doors.`,
  },
  {
    name: "KVS Sidhartha",
    company: "citizens-bank",
    avatar: "/successstories/siddartha.jpg",
    companyLogo: "/successstories/citizens-bank.jpg",
    text: `KodeZ flipped my learning journey. I went from passive watching to active shipping. I learned how to build fast, iterate smart, and explain clearly. That made all the difference.`,
  },
  {
    name: "MD Muzaffar Ali",
    company: "Wipro",
    avatar: "/successstories/muzaffar.jpg",
    companyLogo: "/successstories/wipro.png",
    text: `KodeZ gave me velocity. Every week I shipped something new—no fluff, just code that mattered. That habit of building fast helped me stand out in interviews and adapt quickly in my role.`,
  },
  {
    name: "Darani P",
    company: "TCS",
    avatar: "/successstories/darani.jpg",
    companyLogo: "/successstories/tcs.png",
    text: `KodeZ taught me that showing is better than telling. Instead of saying “I know React,” I built and deployed a real project. That single demo impressed my interviewers at TCS.`,
  },
];

const Testimonials = () => {
  const [startIndex, setStartIndex] = useState(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const nextSlide = () =>
    setStartIndex((i) => (i + 1) % testimonials.length);
  const prevSlide = () =>
    setStartIndex((i) => (i - 1 + testimonials.length) % testimonials.length);

  // 🔁 Listen to screen resize and update screenWidth state
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 4000);

    return () => clearInterval(interval);
  }, []);
  // ✅ USE screenWidth state instead of window.innerWidth
  const getVisibleCards = (arr, idx) => {
    const count = screenWidth <= 767 ? 1 : screenWidth < 1024 ? 2 : 3;
    return Array.from({ length: count }, (_, i) => arr[(idx + i) % arr.length]);
  };

  return (
    <div id="testimonials" className="testimonials-section">
      <div class="d-flex flex-column align-items-center"><h2 className="main-heading">Testimonials</h2></div>
      <h3 className="section-heading glow-heading floating-subheading align-items-center">
        What Our Learners Say
      </h3>

      <div className="testimonials-carousel">
        <button className="nav-btn left" onClick={prevSlide}>‹</button>

        <div className="testimonials-cards">
          {getVisibleCards(testimonials, startIndex).map((t, i) => (
            <div key={i} className="testimonial-card pulse-card">
              <div className="testimonial-header">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="student-avatar"
                />
                <div className="name-company">
                  <div className="name">{t.name}</div>
                  <img src={t.companyLogo} alt={t.company} className="company-logo" />
                </div>
              </div>
              <p className="testimonial-text">"{t.text}"</p>
            </div>
          ))}
        </div>

        <button className="nav-btn right" onClick={nextSlide}>›</button>
      </div>
    </div>
  );
};

export default Testimonials;